import React from 'react';
import PropTypes from 'prop-types';
import BEMHelper from '@ynap/bem-helper';

const bem = new BEMHelper('Swatch');

const Swatch = (props) => {
    const { className, colour, colourClass, label, labelClass, notBuyable, url } = props;

    const background = (url && `url("${url}")`) || (colour && `#${colour}`);
    const fallbackModifier = background ? '' : 'fallback';
    const whiteSpecialCase = ['FFF', 'FFFFFF'].includes(colour?.toUpperCase()) ? 'whiteSwatch' : '';
    const notBuyableModifier = notBuyable ? 'notBuyable' : '';

    const backgroundStyle = background && { background };
    const imageModifiers = [whiteSpecialCase, notBuyableModifier, fallbackModifier];

    return (
        <div className={bem(null, null, className)}>
            <span className={bem('image', imageModifiers, colourClass)} style={{ ...backgroundStyle }} />
            {label && <span className={bem('label', null, labelClass)}>{label}</span>}
        </div>
    );
};

Swatch.propTypes = {
    colour: PropTypes.string,
    active: PropTypes.bool,
    url: PropTypes.string,
    label: PropTypes.string,
    labelClass: PropTypes.string,
    colourClass: PropTypes.string,
    className: PropTypes.string,
    badge: PropTypes.object,
    notBuyable: PropTypes.bool,
};

export default Swatch;
